import React from 'react';

/**
 * Tabela padrão das listagens.
 *
 * `loading` e `emptyMessage` são opcionais: sem eles a tabela se comporta como
 * antes, mas quando não há linhas o usuário passa a ver uma mensagem explícita
 * em vez de um corpo de tabela vazio — que era indistinguível de uma falha de
 * carregamento.
 */
const Table = ({
  columns,
  data,
  loading = false,
  emptyMessage = 'Nenhum registro encontrado.',
  emptyHint = 'Revise os filtros aplicados ou cadastre um novo registro.',
}) => {
  const linhas = Array.isArray(data) ? data : [];
  const semDados = !loading && linhas.length === 0;

  return (
    <div className="w-full min-w-0">
      <div className="overflow-x-auto rounded shadow bg-white min-w-0">
        <table className="min-w-[700px] w-full table-auto divide-y divide-gray-200">
          <thead className="bg-green-600 text-white">
            <tr>
              {columns.map((col) => (
                <th key={col.accessor} className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wider">
                  {col.Header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-100">
            {loading && (
              <tr>
                <td colSpan={columns.length} className="px-4 py-10 text-center text-sm text-gray-500" data-testid="tabela-carregando">
                  <span className="inline-block w-5 h-5 mr-2 align-middle border-2 border-gray-300 border-t-green-600 rounded-full animate-spin" />
                  Carregando registros...
                </td>
              </tr>
            )}

            {semDados && (
              <tr>
                <td colSpan={columns.length} className="px-4 py-10 text-center" data-testid="tabela-vazia">
                  <p className="text-sm font-medium text-gray-700">{emptyMessage}</p>
                  {emptyHint && <p className="text-xs text-gray-500 mt-1">{emptyHint}</p>}
                </td>
              </tr>
            )}

            {!loading && linhas.map((row, idx) => (
              <tr key={idx} className="hover:bg-gray-50 transition duration-200">
                {columns.map((col) => (
                  <td key={col.accessor} className="px-4 py-2 text-sm text-left whitespace-nowrap">
                    {col.Cell ? col.Cell(row[col.accessor], row) : row[col.accessor]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
